import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../../components/Header";
import axios from "axios";
import ContentNew from "../../components/DetailArea/ContentNew";
import Footer from "../../components/Footer";
import HeroSection from "../../components/RentRealEstate/Herosection";

function AllProperties() {
  const [data, setData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [searchResult, setSearchResult] = useState(null);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const city = queryParams.get("city");

  useEffect(() => {
    async function getData() {
      if (!city) {
        console.warn("No city found in URL query.");
        setData([]);
        setFilterData([]);
        return;
      }

      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/properties/by-location`,
          { params: { location: city } }
        );

        setData(res.data);
        setFilterData(res.data);
        setSearchResult({
          city,
          propertyType: "Any",
          price: "Any",
          complete: "Any",
        });
      } catch (err) {
        console.error("Error fetching properties by location:", err);
        setData([]);
        setFilterData([]);
      }
    }

    getData();
  }, [city]);

  function handleFilter(searchResult) {
    setSearchResult(searchResult);
    let filtered = [...data];

    if (searchResult.propertyType !== "Any") {
      filtered = filtered.filter(
        (property) => property.propertyType === searchResult.propertyType
      );
    }

    if (searchResult.price !== "Any") {
      filtered = filtered.filter(
        (property) => parseInt(property.price) > parseInt(searchResult.price)
      );
    }

    if (searchResult.complete !== "Any") {
      filtered = filtered.filter(
        (property) => property.propertyStatus === searchResult.complete
      );
    }

    setFilterData(filtered);
  }

  return (
    <div>
      <Navbar />
      <HeroSection
        searchResult={searchResult}
        setSearchResult={setSearchResult}
        handleFilter={handleFilter}
      />
      <ContentNew data={filterData} />
      <Footer />
    </div>
  );
}

export default AllProperties;
